import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import i18n from './i18n'
import { useAuthStore } from './stores/auth'
import { useLocaleStore } from './stores/locale'
import { isAbortError } from './lib/api'
import { useToast } from './composables/useToast'
import { initAnalytics, captureException } from './lib/analytics'
import './style.css'

const app = createApp(App)
const pinia = createPinia()
const toast = useToast()

app.use(pinia)
app.use(i18n)

useLocaleStore().hydrate()

initAnalytics()

// Global Vue error handler — catches uncaught errors in components
app.config.errorHandler = (err) => {
  if (isAbortError(err)) return
  console.error('[Vue error]', err)
  captureException(err)
  toast.error('Something went wrong. Please try again.')
}

// Catch unhandled promise rejections (e.g. forgotten awaits)
window.addEventListener('unhandledrejection', (event) => {
  if (isAbortError(event.reason)) return
  console.error('[Unhandled rejection]', event.reason)
  captureException(event.reason)
  toast.error('An unexpected error occurred.')
})

// Init auth BEFORE router so the guard sees the restored session
const auth = useAuthStore()
auth.init().then(() => {
  app.use(router)
  app.mount('#app')
})
